const mainMenuData = {
  left: [
    {
      name: 'Dresses',
      url: `https://${process.env.SHOPIFY_DOMAIN}/collections/all-dresses`,
      children: null,
    },
    {
      name: 'Bridal',
      url: `https://${process.env.SHOPIFY_DOMAIN}/pages/amsale-bridal`,
      children: [
        {
          name: 'Amsale',
          url: `https://${process.env.SHOPIFY_DOMAIN}/collections/amsale-bridal`,
        },
        {
          name: 'Nouvelle Amsale',
          url: `https://${process.env.SHOPIFY_DOMAIN}/collections/nouvelle-amsale-bridal`,
        },
        {
          name: 'Amsale Archive',
          url: `https://${process.env.SHOPIFY_DOMAIN}/collections/amsale-archive`,
        },
        {
          name: 'Accessories',
          url: `https://${process.env.SHOPIFY_DOMAIN}/collections/accessories`,
        },
        {
          name: 'Trunk Shows',
          url: `https://${process.env.SHOPIFY_DOMAIN}/pages/trunk-shows`,
        },
      ],
    },
    {
      name: 'Little White Dresses',
      url: `https://${process.env.SHOPIFY_DOMAIN}/pages/little-white-dress`,
      children: [
        {
          name: 'Shop All',
          url: `https://${process.env.SHOPIFY_DOMAIN}/collections/little-white-dresses`,
        },
      ],
    },
    {
      name: 'Bridemaids',
      url: `https://${process.env.SHOPIFY_DOMAIN}/pages/bridesmaids`,
      children: [
        {
          name: 'Amsale',
          url: `https://${process.env.SHOPIFY_DOMAIN}/collections/amsale-bridesmaids`,
        },
        {
          name: 'Nouvelle Amsale',
          url: `https://${process.env.SHOPIFY_DOMAIN}/collections/nouvelle-amsale-collection`,
        },
        {
          name: 'Swatches',
          url: `https://${process.env.SHOPIFY_DOMAIN}/collections/swatch`,
        },
      ],
    },
    {
      name: 'Evening',
      url: `https://${process.env.SHOPIFY_DOMAIN}/pages/evening`,
      children: [
        {
          name: 'Shop All',
          url: `https://${process.env.SHOPIFY_DOMAIN}/collections/evening`,
        },
        {
          name: 'Dresses',
          url: `https://${process.env.SHOPIFY_DOMAIN}/collections/evening-dresses`,
        },
        {
          name: 'Mother of the Bride/Groom',
          url: `https://${process.env.SHOPIFY_DOMAIN}/collections/mother-of-the-bride`,
        },
        {
          name: 'Summer Soiree Edit',
          url: `https://${process.env.SHOPIFY_DOMAIN}/collections/summer-soiree-edit`,
        },
        {
          name: 'Wedding Guest Edit',
          url: `https://${process.env.SHOPIFY_DOMAIN}/collections/wedding-guest-edit`,
        },
      ],
    },
    {
      name: 'Bespoke',
      children: [
        {
          name: 'Amsale x You Bridal',
          url: `https://${process.env.SHOPIFY_DOMAIN}/collections/amsale_x_you_bridal`,
        },
        {
          name: 'Amsale x You Bridesmaids',
          url: `https://${process.env.SHOPIFY_DOMAIN}/collections/amsale_x_you_bridesmaids`,
        },
      ],
    },
  ],
  right: [
    {
      name: 'Book an Appointment',
      url: '#',
      children: [
        {
          name: 'Visit Soho Flagship',
          url: `${process.env.PROXY_PATH}/booking/onboarding`,
        },
        {
          name: 'Book a Virtual Appointment',
          url: `${process.env.PROXY_PATH}/booking/virtual-appointment`,
        },
        {
          name: 'Store Locator',
          url: `https://${process.env.SHOPIFY_DOMAIN}/pages/store-locator`,
        },
        {
          name: 'Alterations',
          url: `https://${process.env.SHOPIFY_DOMAIN}/a/app/find-locations`,
        },
        {
          name: 'FAQ',
          url: `https://${process.env.SHOPIFY_DOMAIN}/pages/faq`,
        },
      ],
    },
    {
      name: 'Trunk Shows',
      url: `https://${process.env.SHOPIFY_DOMAIN}/pages/trunk-shows`,
      children: null,
    },
    {
      name: 'About',
      url: '#',
      children: [
        {
          name: 'Our Story',
          url: `https://${process.env.SHOPIFY_DOMAIN}/pages/the-designer`,
        },
        {
          name: 'Amsale Aspire',
          url: `https://${process.env.SHOPIFY_DOMAIN}/pages/amsale-aspire`,
        },
        {
          name: 'Real Brides',
          url: `https://${process.env.SHOPIFY_DOMAIN}/blogs/real-brides`,
        },
        {
          name: 'Blog',
          url: `https://${process.env.SHOPIFY_DOMAIN}/blogs/amsale`,
        },
        {
          name: 'Press',
          url: `https://${process.env.SHOPIFY_DOMAIN}/blogs/press`,
        },
      ],
    },
  ],
};

export { mainMenuData };
